import React from 'react'
import Navbar from '../../components/common/Navbar'
import Footer from '../../components/common/Footer'
import Inqure from './inqure'
import Ccform from './ccform'

function Contacts() {
    return (
        <>
            <Navbar />
            <Inqure />
            <Ccform />
            <Footer />
        </>
    )
}

export default Contacts